import { Checklist } from './Checklist'
import { CollectionList } from './CollectionList'
import { GroceryList } from './GroceryList'
import { PurchaseList } from './PurchaseList'
import { TaskList } from './TaskList'
import type { List, ListItem } from '../lib/types'

/**
 * One list's content, with no chrome around it: the dispatch on `list.kind`
 * that `ListDetail` used to be, and nothing else. Every kind draws its own
 * head (Groceries' "N to get", Purchases' segments, the checklist's ring, the
 * task add field), its own writes, error banner and empty state.
 *
 * Two callers, and the split is what keeps each one honest about what it
 * adds. `Lists` mounts it inline under the chip row, where the chip says
 * which list it is — no title, no back arrow. `ListDetail` mounts it as a
 * screen of its own, with the back bar and the list's name above it.
 *
 * `.lists-detail` is the one root the five kinds share, which is what a row
 * rule for "a list's detail" has to hang on (`app.css`): `.u-row--list` is
 * also every sheet's and the Lists index's row, and `.lists-group` is the
 * index's group too. It is drawn here, not by the callers, so a caller cannot
 * forget it and lose the row rules.
 */
export function ListBody({ list, items, recipe = null, onRecipeDone }: {
  list: List; items: ListItem[]
  /** B2: a recipe the route delivered for a grocery list (`Lists.tsx`). */
  recipe?: string | null
  onRecipeDone?: () => void
}) {
  const body =
    list.kind === 'template' ? <Checklist list={list} items={items} />
    : list.kind === 'grocery' ? <GroceryList list={list} items={items} recipe={recipe} onRecipeDone={onRecipeDone} />
    : list.kind === 'task' ? <TaskList list={list} items={items} />
    : list.kind === 'buy' ? <PurchaseList list={list} items={items} />
    : <CollectionList list={list} items={items} />
  return <div className="lists-detail">{body}</div>
}
